import * as React from 'react';
import { TextInput } from '../../../components/form-elements/TextInput';
import { InputChangeCallbackWithID } from '../../../models/utilities/function-types';
import { DeliveryStatus } from '../../models/enums/delivery-status';
import { DeliveryShipmentAction } from '../../models/shipments/shipment-action';

interface IProps {
    delivery        : DeliveryShipmentAction;
    onPARSChange    : InputChangeCallbackWithID;
}

export const ShipmentActionCustomsRow = (props: IProps) => {

    const handlePARSChange = (e : React.FormEvent<HTMLInputElement>) => {
        props.onPARSChange(props.delivery.id, e);
    };

    /**
     * Get the panel title based on the data we have available
     */
    const getPanelTitle = () => {
        return props.delivery.address && props.delivery.address.addressLine1.length > 0
            ? <React.Fragment>
                <span>{props.delivery.address.addressLine1}</span><br/>
                <span>
                    {
                        `${props.delivery.address.city}, 
                    ${props.delivery.address.stateProvince} 
                    ${props.delivery.address.postalCode}`
                    }
                </span>
            </React.Fragment>
            : <React.Fragment>
                <span>PICKUPS</span>
                <span>ONLY</span>
            </React.Fragment>;
    };

    return  <tr>
                <td>
                    { getPanelTitle() }
                </td>
                <td>
                    { props.delivery.dealerId }
                </td>
                <td className="row-cell">
                    <TextInput
                        type="text"
                        id={`${ props.delivery.id }-customs-row`}
                        value={ props.delivery.parsNumber }                
                        label=""
                        disable={ props.delivery.status !== DeliveryStatus.Open }
                        onChange={ handlePARSChange }
                    />
                </td>
            </tr>;
};
